<div class="bulk-cost-dialog">
    <h2 mat-dialog-title>Bulk Cost Manager</h2>
    <p class="dialog-subtitle">Apply cost values to {{ data.selectedFields.length }} selected field(s).</p>

    <mat-dialog-content>
        <div *ngIf="isLoading" class="loading-text">Loading cost options...</div>

        <div *ngIf="!isLoading" class="cost-inputs-container">
            <!-- Fixed Input Cost -->
            <div class="cost-row">
                <mat-form-field class="cost-field-input" appearance="outline">
                    <mat-label>Fixed input cost</mat-label>
                    <input matInput type="number" [(ngModel)]="fixedCostValue" min="0" max="1000000">
                </mat-form-field>
            </div>

            <!-- VRT / As Applied cost inputs -->
            <div *ngFor="let input of costInputs" class="cost-row">
                <mat-form-field class="cost-field-input" appearance="outline">
                    <mat-label>{{ input.type }}</mat-label>
                    <input matInput type="number" [(ngModel)]="input.costValue" min="0" max="1000000">
                </mat-form-field>
                <mat-form-field class="cost-field-uom" appearance="outline">
                    <mat-label>Unit of measure</mat-label>
                    <mat-select [(ngModel)]="input.unitOfMeasureId">
                        <mat-option *ngFor="let uom of unitsOfMeasure" [value]="uom.id">{{ uom.description }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="costInputs.length === 0 && !isLoading" class="no-data-text">
                No VRT or As Applied cost options available for the selected fields.
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="apply()" [disabled]="isLoading">Apply</button>
    </mat-dialog-actions>
</div>
